<template>
  <v-tabs
    :background-color="getAppBarColor"
    class="elevation-2"
    dark
    :grow="true"
  >
    <v-tabs-slider></v-tabs-slider>

    <v-tab v-for="parametro in parametros" :key="parametro.id">
      {{ parametro.id }}
    </v-tab>

    <v-tab-item v-for="parametro in parametros" :key="parametro.id">
      <v-card flat tile>
        <TableConsorcio :consorcio="parametro" v-if="parametro.id === 'consorcio'"/>
        <TableFinanciamento :financiamento="parametro" v-if="parametro.id === 'financiamento'"/>
        <TableFinanciamentoProdutoForca :financiamentoProdutoForca="parametro" v-if="parametro.id === 'produtoForca'"/>
        <TableLeads :lead="parametro" v-if="parametro.id === 'leads'"/>
        <TableComissao :comissao="parametro" v-if="parametro.id === 'comissao'"/>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: 'Parametros',

  components: {
    TableConsorcio: () => import('./TableConsorcio'),
    TableFinanciamento: () => import('./TableFinanciamento'),
    TableFinanciamentoProdutoForca: () => import('./TableFinanciamentoProdutoForca'),
    TableLeads: () => import('./TableLeads'),
    TableComissao: () => import('./TableComissao')
  },

  data() {
    return {
      parametros: null
    };
  },

  computed: {
    ...mapGetters("parametros_empresa", ["getParametros"])
  },

  watch: {
    getParametros(parametros) {
      this.parametros = parametros
    }
  }
};
</script>
